module.exports = __webpack_public_path__ + "img/search_icon_gray.2f73e11d.svg";